import type { FaireProductEntity } from "../../entity_types/product";

export const p_5eo13zvy73: FaireProductEntity = {
  token: "p_5eo13zvy73",
  type: "product",
  name: "Indigo Flowers Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6c0b45223bcb82d20d0ebceebcdc61daf291871db97bf39596e009c0d995e55b/1558458780.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e61ff4e9f4702910af500bc749b3bd72833475ae0cddf9f36db0e388bf71a516/1558458813.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:10.057Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
